import { Component, OnInit } from '@angular/core';
import {AdminQuestionSelectionListService} from './admin-question-selection-list.service';

@Component({
  selector: 'app-admin-question-selection-list',
  templateUrl: './admin-question-selection-list.component.html',
  styleUrls: ['./admin-question-selection-list.component.css']
})
export class AdminQuestionSelectionListComponent implements OnInit {

  constructor(public selectionSv: AdminQuestionSelectionListService) { }

  ngOnInit() {
  }

}
